/* 

*/

import Produtos from "pages/Produtos";

export default function ProdutosPage() {
  return <Produtos />;
}
